// 预览txt
import axios from 'axios';

const transformData = (data) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsText(data, 'UTF-8');
  });
};

async function txtfile(params) {
  try {
    const response = await axios.get(params, {
      responseType: "blob",
      transformResponse: [async (data) => await transformData(data)],
    });
    const txtdata = response.data;
    return txtdata;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
}

export default txtfile;
